<template>
  <div>
    <!--    <action-bar :path="'/lawyer/lawyer_CAD'"></action-bar>-->
    <div v-show="false">{{ applicationConditions }}</div>
    {{ allApplicantComputed }}
    <div class="card oc-generic-card-body">
      <div class="row mb-3">
        <div class="col-md-4">
          <h6 class="text-primary mt-3">APPLICATION CONDITIONS</h6>
        </div>
        <div class="col-md-8">
          <!--            todo remember to uncomment after lawyer demo. Generally we can only see the deal complete button if the application is in APPROVAL and all the conditions have been REVIEWED. During the lawyer demo I was as asked to remove that condition and let the button be available all the time.-->
          <!--            <el-button v-if="appStatus && appStatus.toLowerCase() === 'approval' && conditionsMet && !dealCompleted"-->
          <el-button
            v-if="!dealCompleted && rowIsSelected"
            type="danger"
            class="ocAddDelButt ml-2 mt-2"
            style="float: right"
            plain
            size="small"
            v-on:click="removeApplicationCondition"
          >
            <i class="fa fa-trash" aria-hidden="true"></i>
          </el-button>
          <div class="col mt-2 pr-0" v-if="!dealCompleted">
            <el-button
              type="primary"
              style="float: right; max-width: 150px"
              plain
              class="ocAddDelButt mr-0"
              size="small"
              @click="addApplicationConditions"
              >New Condition
            </el-button>

            <el-button
              type="primary"
              plain
              style="float: right; max-width: 150px"
              class="ocAddDelButt mr-2"
              size="small"
              @click="conditionsTemplate"
              >Conditions Template
            </el-button>
          </div>
        </div>
      </div>

      {{ eventHistories }}
      <div>
        <el-table
          v-loading="applicationConditionsLoading"
          element-loading-text="Loading..."
          class="table-full-width"
          ref="multipleTable"
          :data="conditionDetails"
          @cell-click="onCellClick"
          style="width: 100%; color: black"
          size="small"
          border
          highlight-current-row
          show-header
          @selection-change="handleSelectionChange"
          fit
        >
          <el-table-column
            type="selection"
            min-width="38"
            :selectable="checkRequestedBy"
          >
          </el-table-column>

          <el-table-column type="expand" min-width="20">
            <template slot-scope="props">
              <ul>
                <li v-if="props.row.documentName">
                  <span style="font-weight: bold">Document Name: </span>
                  {{ props.row.documentName }}
                </li>
                <li v-if="props.row.conditionDescription">
                  <span style="font-weight: bold">Description: </span>
                  {{ props.row.conditionDescription }}
                </li>
              </ul>
            </template>
          </el-table-column>

          <el-table-column
            prop="conditionName"
            label="Condition Name"
            min-width="130"
            show-overflow-tooltip
          >
          </el-table-column>

          <el-table-column
            prop="applicantName"
            label="Applicant"
            min-width="160"
            show-overflow-tooltip
          >
            <!--          <el-table-column prop="name" label="Applicant" min-width="160" show-overflow-tooltip>-->
            <!--<template slot-scope="scope">
              <editable-column-dropdown
                :is-editing="isEditing" :scope="scope" :editing="editing" property="name"
                @blur-input="onCellBlur" @enter-input="onCellBlur" :options="appliesTo">
              </editable-column-dropdown>
            </template>-->
          </el-table-column>

          <el-table-column
            prop="fulfilledDate"
            label="Uploaded Date"
            min-width="130"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <editable-column-date-time
                :scope="scope"
                :editing="editing"
                property="fulfilledDate"
              >
              </editable-column-date-time>
            </template>
          </el-table-column>

          <el-table-column
            prop="userName"
            label="Uploaded By"
            min-width="100"
            show-overflow-tooltip
          >
          </el-table-column>

          <el-table-column
            prop="status"
            label="Status"
            min-width="80"
            show-overflow-tooltip
          >
          </el-table-column>

          <el-table-column
            prop="reviewed"
            label="Reviewed"
            min-width="80"
            v-if="!dealCompleted && firmType === 'broker'"
          >
            <template slot-scope="scope">
              <el-checkbox
                style="padding-left: 40%"
                v-model="scope.row['reviewed']"
                @blur="saveApplicationConditionDetails(scope.row, $event)"
                @input="saveApplicationConditionDetails(scope.row, $event)"
              >
              </el-checkbox>
            </template>
          </el-table-column>
          <el-table-column
            prop="reviewed"
            label="Reviewed"
            min-width="80"
            v-if="dealCompleted && firmType === 'broker'"
          >
            <template slot-scope="scope">
              <el-checkbox style="padding-left: 40%" disabled> </el-checkbox>
            </template>
          </el-table-column>

          <!--     Broker checkbox view-->
          <el-table-column
            v-if="firmType === 'broker'"
            min-width="90"
            prop="sharedWithLender"
            label="Share with Lender"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-checkbox
                style="padding-left: 40%"
                v-model="scope.row['sharedWithLender']"
                @change="checkSharedConditionsWithLender(scope.row, $event)"
                :disabled="scope.row['requestedBy'] !== 'oci'"
              >
              </el-checkbox>
            </template>
          </el-table-column>

          <el-table-column
            v-if="firmType === 'broker'"
            min-width="90"
            prop="sharedWithLawyer"
            label="Share with Lawyer"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-checkbox
                style="padding-left: 40%"
                v-model="scope.row['sharedWithLawyer']"
                @change="checkSharedConditionsWithLawyer(scope.row, $event)"
                :disabled="scope.row['requestedBy'] !== 'oci'"
              >
              </el-checkbox>
            </template>
          </el-table-column>

          <!--   Lender checkbox view-->
          <el-table-column
            v-if="firmType === 'lender'"
            min-width="90"
            prop="sharedWithBroker"
            label="Share with OCI"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-checkbox
                style="padding-left: 40%"
                v-model="scope.row['sharedWithBroker']"
                @change="checkSharedConditionsWithBroker(scope.row, $event)"
                :disabled="scope.row['requestedBy'] !== 'lender'"
              >
              </el-checkbox>
            </template>
          </el-table-column>

          <el-table-column
            v-if="firmType === 'lender'"
            min-width="90"
            prop="sharedWithLawyer"
            label="Share with Lawyer"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-checkbox
                style="padding-left: 40%"
                v-model="scope.row['sharedWithLawyer']"
                @change="checkSharedConditionsWithLawyer(scope.row, $event)"
                :disabled="scope.row['requestedBy'] !== 'lender'"
              >
              </el-checkbox>
            </template>
          </el-table-column>

          <!--  Lawyer checkbox view-->
          <el-table-column
            v-if="firmType === 'lawyer'"
            min-width="90"
            prop="sharedWithLender"
            label="Share with Lender"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-checkbox
                style="padding-left: 40%"
                v-model="scope.row['sharedWithLender']"
                @change="checkSharedConditionsWithLender(scope.row, $event)"
                :disabled="scope.row['requestedBy'] !== 'lawyer'"
              >
              </el-checkbox>
            </template>
          </el-table-column>

          <el-table-column
            v-if="firmType === 'lawyer'"
            min-width="90"
            prop="sharedWithBroker"
            label="Share With OCI"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-checkbox
                style="padding-left: 40%"
                v-model="scope.row['sharedWithBroker']"
                @change="checkSharedConditionsWithBroker(scope.row, $event)"
                :disabled="scope.row['requestedBy'] !== 'lawyer'"
              >
              </el-checkbox>
            </template>
          </el-table-column>

          <el-table-column width="140" label="Actions">
            <template slot-scope="scope">
              <div class="row ml-1">
                <el-button
                  type="success"
                  v-if="!dealCompleted"
                  plain
                  class="mr-1 documentAction"
                  id="existingFile"
                  @click="selectDocument(scope.row)"
                >
                  <i class="now-ui-icons arrows-1_cloud-upload-94"></i>
                </el-button>
                <el-button
                  type="info"
                  plain
                  v-if="dealCompleted"
                  class="mr-1 documentAction"
                  id="existingFileDisabled"
                  disabled
                >
                  <i class="now-ui-icons arrows-1_cloud-upload-94"></i>
                </el-button>
                <el-button
                  :type="scope.row.documentId ? 'primary' : 'info'"
                  plain
                  :disabled="!scope.row.documentId"
                  class="mr-1 documentAction"
                  @click="previewDocument(scope.row)"
                >
                  <i class="now-ui-icons arrows-1_cloud-download-93"></i>
                </el-button>
                <el-button
                  :type="scope.row.documentId ? 'danger' : 'info'"
                  plain
                  class="documentAction"
                  :disabled="!scope.row.documentId"
                  @click="deleteDocument(scope.row)"
                >
                  <i class="fa fa-trash"></i>
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div
          slot="footer"
          class="
            col-12
            d-flex
            justify-content-center justify-content-sm-between
            flex-wrap
            pt-3
            mb-0
            pb-0
          "
        >
          <el-pagination
            @current-change="changePage"
            layout="prev, pager, next"
            small
            :current-page="pagination.currentPage"
            :pager-count="7"
            :page-size="pagination.perPage"
            :total="total"
          >
          </el-pagination>
          <div>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <div>
            <p class="oci-blue">
              Display per page:
              <el-select
                class=""
                style="width: 100px"
                v-model="pagination.perPage"
                size="mini"
                @change="displayPerPage"
                placeholder=" "
              >
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </p>
          </div>
        </div>

        <modal
          :show.sync="modals.notice"
          footerClasses="justify-content-center"
          type="notice"
        >
          <h5 slot="header" class="modal-title text-align-center">
            Select Document
          </h5>
          <template>
            <div class="row ml-2 mt-3">
              <label>New Document</label>
              <label class="ocAddDelButt btn btn-sm btn-success">
                <input
                  type="file"
                  id="file"
                  ref="file"
                  style="display: none; width: 150px"
                  v-on:change="uploadDocument($event)"
                />Upload From Computer
              </label>
            </div>
            <div class="row ml-2 mt-3">
              <label>Existing document</label>
              <select
                class="form-control"
                style="width: 150px"
                @change="addToExistingDocument"
                v-model="selectedDocumentId"
              >
                <option
                  v-for="(doc, index) in documents"
                  :value="doc.documentId"
                >
                  {{ doc.name }}
                </option>
              </select>
            </div>
          </template>
        </modal>
      </div>

      <div v-if="!dealCompleted && firmType === 'broker'" class="row">
        <div class="col"></div>
        <el-button
          style="float: right; max-width: 120px"
          type="success"
          plain
          class="mt-2 mr-2"
          size="small"
          @click="showDealCompleteAlert"
          >Deal Complete
        </el-button>
      </div>

      <modal
        :show.sync="modals.dealComplete"
        :showClose="false"        
        footerClasses="justify-content-center"
        type="notice"
      >
        <h5 class="text-center">Select funding lender</h5>
        <template>
          <div class="row mt-4">
            <div class="col-md-4"><label>Funding Lender</label></div>
            <div class="col-md-8">
              <select
                id="addNewFirmType"
                class="form-control"
                v-model="fundingLender"
              >
                <option
                  v-for="item in lenders"
                  :key="item.firmName"
                  :label="item.firmName"
                  :value="item"
                >
                  {{ item.firmName }}
                </option>
              </select>
            </div>
          </div>
          <div class="text-center mt-4">
            <el-button
              type="danger"
              @click="cancelDealComplete"
              plain
              size="medium"
              >Cancel</el-button
            >
            <el-button :type="fundingLender ? 'success' : 'info'" :disabled="!fundingLender" @click="dealComplete" plain size="medium"
              >Complete</el-button
            >
          </div>
        </template>
      </modal>

      <div class="row">
        <div class="col-md-6 col-sm-6" v-if="!dealCompleted">
          <modal
            :show.sync="modals.classic"
            footerClasses="justify-content-center"
            type="notice"
          >
            <h5 slot="header" class="modal-title oci-white">Are you sure?</h5>
            <template>
              <div style="text-align: center">
                <h5>Are you sure?</h5>
              </div>
              <div class="row">
                <div class="col-md-4 offset-md-1">
                  <n-button
                    type="success"
                    @click.native="
                      deleteApplicationCondition(multipleSelection)
                    "
                    >Yes, delete
                  </n-button>
                </div>
                <div class="col-md-4 offset-md-2">
                  <n-button type="danger" @click.native="modals.classic = false"
                    >No, cancel</n-button
                  >
                </div>
              </div>
            </template>
          </modal>
        </div>

        <div class="col-md-12 col-sm-12">&nbsp;</div>
      </div>
    </div>
    <div v-if="addCondition" class="card oc-generic-card-body">
      <h6 v-if="!condition.conditionId" class="text-primary mb-1 mt-3">
        New Condition
      </h6>
      <div style="padding-top: 20px">
        <div class="row">
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-4"><label>Condition</label></div>
              <div class="col-md-8">
                <input
                  type="text"
                  id="addConditionName"
                  class="form-control"
                  placeholder="condition name"
                  v-model="condition.conditionName"
                />
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-4"><label>Description</label></div>
              <div class="col-md-8">
                <input
                  type="text"
                  id="addConditionDescription"
                  class="form-control"
                  placeholder="description"
                  v-model="condition.conditionDescription"
                />
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-4"><label>Applies To</label></div>
              <div class="col-md-8">
                <select
                  id="addNewFirmType"
                  class="form-control"
                  v-model="condition.appliesTo"
                >
                  <option
                    v-for="value in appliesTo"
                    :selected="condition.appliesTo.name"
                    :value="value"
                  >
                    {{ value.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-12">
            <el-button
              v-if="addCondition"
              type="danger"
              style="float: right; width: 70px; height: 30px"
              size="small"
              plain
              @click="cancelSave"
              >Cancel
            </el-button>

            <el-button
              v-if="
                addCondition &&
                (!condition.conditionName || !condition.appliesTo.name)
              "
              type="info"
              style="float: right; width: 70px; height: 30px"
              plain
              class="mr-2"
              disabled
              size="small"
              >Save
            </el-button>

            <el-button
              v-if="
                addCondition &&
                condition.conditionName &&
                condition.appliesTo.name
              "
              type="success"
              plain
              style="float: right; width: 70px; height: 30px"
              size="small"
              class="mr-2"
              @click="saveNewCondition"
              >Save
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div v-show="showConditionsTemplate">
      <condition-set-table
        :dealLevel="true"
        @conditionsTemplate="addConditions"
      >
      </condition-set-table>
    </div>
  </div>
</template>
<script>
/**
 * @author Ankita
 * This is made for the Conditions which are used within a respective loan application. We can either use a condition from the previous defined template or create a new one that will specifically be use only for the respective loan application.
 * This page also lets us upload/preview a document to satisfy a condition.
 * You can also upload an already uploaded document for the application. The documents are saved in AWS buckets. This would just create a link. example - if you want to link a document from the other document page and say it satisfies the respective condition
 * We can also share a condition with OCI/Lawyer or Lender
 * Once conditions are satisfied the broker can review it and complete the deal.
 * */
import {
  Table,
  TableColumn,
  Select,
  Option,
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Pagination,
  Card,
  TabPane,
  Checkbox,
  Tabs,
} from "element-ui";
import { Pagination as NPagination } from "@/common/components/index";
import Notes from "@/broker/components/UserActivityComponents/Notes.vue";
import EditableColumnTypeText from "@/common/components/EditableColumnTypeText";
import EditableColumnTypeDateTime from "@/common/components/EditableColumnTypeDateTime";
import EditableColumnTypeDropdown from "@/common/components/EditableColumnTypeDropdown";
import EditableColumnTypeCheckBox from "@/common/components/EditableColumnTypeCheckBox";
import swal from "sweetalert2";
import ConditionsMultiSelectDropDown from "@/broker/components/conditionsComponents/ConditionsMultiSelectDropDown.vue";
import { Modal } from "@/common/components/index";
import * as perimeters from "@/perimeters";
import ActionBar from "../../../common/components/ActionBar";

export default {
  name: "ApplicationConditions",
  components: {
    ActionBar,
    NPagination,
    [Pagination.name]: Pagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Card.name]: Card,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    Notes,
    Modal,
    [Checkbox.name]: Checkbox,
    "editable-column-text": EditableColumnTypeText,
    "editable-column-date-time": EditableColumnTypeDateTime,
    "editable-column-dropdown": EditableColumnTypeDropdown,
    "editable-column-checkbox": EditableColumnTypeCheckBox,
    "conditions-multiselect-dropdown": ConditionsMultiSelectDropDown,
  },
  async mounted() {
    this.applicationConditionsLoading = true;
    await this.$store.dispatch(
      "getApplicationCondition",
      this.loanApplicationId
    );
    this.getAllApplicants();

    let obj = {
      id: this.loanApplicationId,
      summary: false,
    };
    await this.$store.dispatch("getEventsByLoanId", obj);
    await this.$store.dispatch(
      "getLoanApplicationLenders",
      this.loanApplicationId
    );
    // await this.$store.dispatch('getApplicationCondition', this.loanApplicationId);

    let path = this.$route.path;
    this.firmType = path.split("/")[1];
  },
  data() {
    return {
      fundingLender: null,
      path: null,
      applicationConditionsLoading: true,
      firmType: null,
      pagination: {
        perPage: 10,
        defaultActive: "All",
        currentPage: 1,
        perPageOptions: [10, 20, 40, 80],
        filterOptions: ["All", "Yes", "No"],
        total: 0,
      },
      applicationCondition: null,
      condition: {
        conditionDescription: null,
        conditionName: null,
        fulfilledBy: null,
        appliesTo: {},
      },
      selectedDocumentId: null,
      selectedAppConditionId: null,
      reviewed: false,
      appConditonUploadId: null,
      showConditionsTemplate: false,
      conditionsMet: false,
      dealCompleted: false,
      selectedConditionType: null,
      loanAppId: null,
      editing: null,
      firstPartOfPathName: "https://s3.ca-central-1.amazonaws.com/",
      swalTitle: "",
      swalType: "",
      multipleSelection: [],
      addCondition: false,
      rowIsSelected: false,
      conditionDetails: [],
      applicantConditionDetails: {},
      newConditionList: {
        conditionId: null,
        conditionName: null,
        conditionDescription: null,
        firmProfile: null,
        groupName: null,
      },
      isOpen: false,
      modals: {
        notice: false,
        classic: false,
        dealComplete: false,
      },
    };
  },
  perimeters: [perimeters.lenderPerimeters, perimeters.basePerimeters],
  props: {
    loanApplicationId: null,
  },
  watch: {
    applicationConditions: {
      immediate: false,
      handler() {
        this.displayPerPage();
        this.applicationConditionsLoading = false;
      },
    },
  },
  computed: {
    lenders: {
      get() {
        return this.$store.getters.getLoanApplicationLenders;
      },
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
    },
    width: {
      get() {
        if (this.dealCompleted) {
          return "60px";
        } else {
          return "120px";
        }
      },
    },
    allApplicantComputed: {
      get() {
        this.allApplicants = JSON.parse(
          JSON.stringify(this.$store.getters.allApplicationApplicants)
        );
      },
    },
    appStatus: {
      get() {
        let appApplicants = this.$store.getters.allApplicationApplicants;
        if (
          appApplicants &&
          appApplicants.length > 0 &&
          appApplicants[0].loanApplication.status
        ) {
          return appApplicants[0].loanApplication.status.status;
        } else {
          return null;
        }
      },
    },
    eventHistories: {
      get() {
        let val = this.$store.getters.getEventsByLoanId;
        if (val) {
          // this.ociLog(val);
          // note it is sorted on backend with most recent and position 0
          for (let i = 0; i < val.length; i++) {
            // need to transverse in reverse so most recent takes priority
            if (val[i].eventName === "conditionsMet") {
              this.conditionsMet = true;
              break;
            }
            if (val[i].eventName === "dealComplete") {
              this.dealCompleted = true;
              break;
            }
            if (val[i].eventName === "purchaserDeclined") {
              this.dealCompleted = false;
              break;
            }
          }
        }
      },
    },
    appliesTo: {
      get() {
        let appliesTo = [
          {
            type: "Application",
            name: "Application",
          },
          {
            type: "Applicants",
            name: "Applicants",
          },
        ];
        if (this.$store.getters.allApplicationApplicants) {
          // let applicantEmail = null;
          for (
            let i = 0;
            i < this.$store.getters.allApplicationApplicants.length;
            i++
          ) {
            if (this.$store.getters.allApplicationApplicants[i].applicant) {
              let fullName =
                this.$store.getters.allApplicationApplicants[i].applicant
                  .personProfile.name.firstName +
                " " +
                this.$store.getters.allApplicationApplicants[i].applicant
                  .personProfile.name.lastName;
              let applicantObject = {
                applicationApplicantId:
                  this.$store.getters.allApplicationApplicants[i]
                    .applicationApplicantId,
                name: fullName,
                id: fullName,
              };
              appliesTo.push(applicantObject);
            }
          }
        }
        return appliesTo;
      },
    },
    applicationConditions: {
      get() {
        return this.$store.getters.applicationConditions;
      },
    },
    documents: {
      get() {
        if (this.$store.getters.conditionDocuments) {
          return this.$store.getters.conditionDocuments;
        } else {
          return [];
        }
      },
    },
    isEditing: {
      get() {
        return this.editing !== null;
      },
    },
  },
  methods: {
    async deleteDocument(row) {
      this.applicationConditionsLoading = true;
      await this.$store.dispatch("removeDocument", row.applicationConditionId);
      await this.$store.dispatch(
        "getApplicationCondition",
        this.loanApplicationId
      );
      this.applicationConditionsLoading = false;
    },
    changePage(page) {
      this.pagination.currentPage = page;
      this.displayPerPage();
    },
    checkRequestedBy(value) {
      if (this.firmType && this.firmType === "broker") {
        return value.requestedBy === "oci";
      } else if (this.firmType && this.firmType === "lender") {
        return value.requestedBy === "lender";
      } else if (this.firmType && this.firmType === "lawyer") {
        return value.requestedBy === "lawyer";
      }
    },
    displayPerPage() {
      this.applicationConditionsLoading = true;
      //ApplicationConditions
      if (this.$store.getters.applicationConditions) {
        this.conditionDetails = JSON.parse(
          JSON.stringify(this.$store.getters.applicationConditions)
        );
        this.pagination.total =
          this.$store.getters.applicationConditions.length;
        if (this.conditionDetails.length > this.pagination.perPage) {
          let leftOver =
            this.pagination.total -
            this.pagination.perPage * this.pagination.currentPage;
          if (leftOver < 0) {
            leftOver = 0;
          }
          if (this.pagination.currentPage > 1) {
            this.conditionDetails.splice(
              0,
              this.pagination.perPage * (this.pagination.currentPage - 1)
            );
          } else {
            this.conditionDetails.splice(
              this.pagination.perPage * this.pagination.currentPage,
              leftOver
            );
          }
        }
      }
      this.applicationConditionsLoading = false;
    },
    async dealComplete() {
      this.modals.dealComplete = false;
      this.applicationConditionsLoading = true;
      /* let event = {
                    eventName: 'dealComplete',
                    loanAppId: this.loanApplicationId,
                    appAppId: null,
                    description: 'Deal Complete'
                };
                await this.$store.dispatch('manageEvent', event); */
      let ids = {
        loanId: this.loanApplicationId,
        lenderId: this.fundingLender.firmProfileId,
      };
      await this.$store.dispatch("dealComplete", ids);
      this.fundingLender = null;
      let obj = {
        id: this.loanApplicationId,
        summary: false,
      };
      await this.$store.dispatch("getEventsByLoanId", obj);
      await this.$store.dispatch(
        "getAllAppApplicantsByLoanAppId",
        this.loanApplicationId
      );
      this.dealCompleted = true;
      this.applicationConditionsLoading = false;
    },
    toggle: function () {
      this.isOpen = !this.isOpen;
    },
    show: function () {
      this.isOpen = true;
    },
    hide: function () {
      this.isOpen = false;
    },
    // Set option as selected state and close dropdown.
    set: function (option) {
      this.selected = option;
      this.hide();
    },
    cancelSave() {
      this.addCondition = false;
      this.condition = {
        appliesTo: {},
      };
    },
    conditionsTemplate() {
      this.addCondition = false;
      this.showConditionsTemplate = !this.showConditionsTemplate;
      let object = {
        groupName: "0",
        dealLevel: true,
        loanAppId: this.loanApplicationId,
      };
      this.$store.dispatch("loadConditions", object);
    },

    async addConditions(conditions) {
      this.showConditionsTemplate = false;
      let applicationConditions = [];
      for (let i = 0; i < conditions.length; i++) {
        if (conditions[i].appliesTo === "Applicants") {
          let appApplicants = JSON.parse(
            JSON.stringify(this.$store.getters.allApplicationApplicants)
          );
          for (let j = 0; j < appApplicants.length; j++) {
            applicationConditions.push({
              applicationApplicant: {
                applicationApplicantId: appApplicants[j].applicationApplicantId,
              },
              conditions: {
                conditionId: conditions[i].conditionId,
              },
              loanApplication: {
                loanApplicationId: this.loanApplicationId,
              },
            });
          }
        } else {
          applicationConditions.push({
            conditions: {
              conditionId: conditions[i].conditionId,
            },
            loanApplication: {
              loanApplicationId: this.loanApplicationId,
            },
          });
        }
      }
      await this.$store.dispatch(
        "saveApplicationConditions",
        applicationConditions
      );
    },
    async saveNewCondition() {
      this.condition.dealCondition = true;
      this.condition.active = true;
      let applicationConditionDetails = {
        loanApplicationId: this.loanApplicationId,
        conditionName: this.condition.conditionName,
        conditionDescription: this.condition.conditionDescription,
        appliesTo: this.condition.appliesTo.type,
      };
      // this.ociLog(this.condition.appliesTo);
      if (
        this.condition.appliesTo.type !== "Applicants" &&
        this.condition.appliesTo.type !== "Application" &&
        this.condition.appliesTo != null
      ) {
        applicationConditionDetails.appliesTo = "Applicant";
        applicationConditionDetails.applicationApplicantId =
          this.condition.appliesTo.applicationApplicantId;
      }
      await this.$store.dispatch(
        "addApplicationCondition",
        applicationConditionDetails
      );
      this.condition = {
        conditionName: null,
        appliesTo: {},
      };
      this.addCondition = false;
      this.showConditionsTemplate = true;
    },
    addApplicationConditions() {
      this.showConditionsTemplate = false;
      this.addCondition = true;
      this.applicantConditionDetails.conditionDescription = null;
      this.applicantConditionDetails.conditionName = null;
      this.applicantConditionDetails.groupName = null;
    },
    cancelDealComplete() {
      this.modals.dealComplete = false;
      this.fundingLender = null;
    },
    async showDealCompleteAlert() {
      this.modals.dealComplete = true;
      /*  await swal({
        title: "Deal Complete",
        html: `<div>Are you sure all conditions have been met?</div>
                <select
                  id="addNewFirmType"
                  class="form-control"
                  v-model="fundingLender">
                  <option
                    v-for="item in lenders"
                    :key="item.firmName"
                    :label="item.firmName"
                    :value="item">
                    {{ item.firmName }}
                  </option>
                </select>`,
        showConfirmButton: true,
        showCancelButton: true,
        buttonsStyling: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          this.dealComplete();
        }
      }); */
    },
    async saveApplicationConditionDetails(value) {
      let reviewedCount = 0;
      await this.$store.dispatch("reviewedConditions", value);
      for (
        let i = 0;
        i < this.$store.getters.applicationConditions.length;
        i++
      ) {
        if (this.$store.getters.applicationConditions[i].reviewed) {
          reviewedCount++;
        }
      }
      if (reviewedCount === this.$store.getters.applicationConditions.length) {
        let event = {
          eventName: "conditionsMet",
          loanAppId: this.loanApplicationId,
          appAppId: null,
          description: "Conditions Met",
          appUserId: this.$store.getters.appUser.userId,
        };
        await this.$store.dispatch("manageEvent", event);
        await this.$store.dispatch("getEventsByLoanId", this.loanApplicationId);
        await this.$store.dispatch(
          "getAllAppApplicantsByLoanAppId",
          this.loanApplicationId
        );
      }
    },
    onCellBlur(object) {
      this.editing = null;
    },
    onCellClick(row, column, cell, event) {
      this.editing = {
        row,
        column,
        cell,
      };
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      if (val.length > 0) {
        this.rowIsSelected = true;
      } else {
        this.rowIsSelected = false;
      }
    },
    checkStatus() {
      this.$store.dispatch("conditionUploadStatus", this.appConditonUploadId);
      if (this.$store.getters.conditionUploadStatus === "saved") {
        clearInterval(this.savingStatus);
        this.$store.commit("CONDITION_UPLOAD_STATUS", null);
        // this.saved(true);
        this.$store.dispatch("getApplicationCondition", this.loanApplicationId);
      }
    },
    async uploadDocument(e) {
      this.modals.notice = false;
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.appConditonUploadId =
        this.applicationCondition.applicationConditionId;
      this.file = files[0];
      let extension = this.file.name.substring(
        this.file.name.lastIndexOf(".") + 1,
        this.file.name.length
      );
      if (
        extension.toLowerCase() === "pdf" ||
        extension.toLowerCase() === "jpg" ||
        extension.toLowerCase() === "jpeg" ||
        extension.toLowerCase() === "png" ||
        extension.toLowerCase() === "doc" ||
        extension.toLowerCase() === "docx" ||
        extension.toLowerCase() === "xls" ||
        extension.toLowerCase() === "xlsx" ||
        extension.toLowerCase() === "txt" ||
        extension.toLowerCase() === "msg"
      ) {
        let type = this.file.name.split(".")[1];
        let myNewFile = new File(
          [this.file],
          "oci-" +
            this.applicationCondition.loanApplicationId +
            "-" +
            this.applicationCondition.conditionName +
            "." +
            type,
          { type: type }
        );
        let formData = new FormData();
        formData.append("file", myNewFile);
        formData.append(
          "appConditionId",
          this.applicationCondition.applicationConditionId
        );
        formData.append("profileId", this.applicationCondition.profileId);
        formData.append(
          "loanAppId",
          this.applicationCondition.loanApplicationId
        );
        formData.append(
          "appAppId",
          this.applicationCondition.applicationApplicantId
        );
        this.applicationConditionsLoading = true;
        await this.$store
          .dispatch("uploadApplicationConditionsDocument", formData)
          .then(() => {
            this.applicationConditionsLoading = false;
            this.ociLog(
              "uploadFile inside of ApplicationCondition component called!"
            );
            if (this.$store.getters.confirmEmailSent) {
              this.showSwal("Uploaded Successfully", "", "success");
            } else {
              this.showSwal(
                "Error Occurred",
                "Retry or contact your admin",
                "error"
              );
            }
          });
      } else {
        this.showSwal(
          "Wrong file format",
          "Only jpg, jpeg, png, doc, docx, xls, xlsx, txt allowed",
          "error"
        );
      }
      await this.$store.dispatch(
        "getApplicationCondition",
        this.loanApplicationId
      );
    },
    previewDocument(currentRowObject) {
      if (currentRowObject.documentId && currentRowObject.documentId !== 0) {
        let formData = new FormData();
        if (currentRowObject.documentName) {
          let type = currentRowObject.documentName.split(".")[1];
          formData.append("file", currentRowObject.documentName);
          formData.append("type", type);
          formData.append("profileId", currentRowObject.profileId);
          formData.append("appCondId", currentRowObject.applicationConditionId);
          this.$store.dispatch("previewConditionsFile", formData).then(() => {
            // this.ociLog("downloadFile inside of component called!")
          });
        }
      } else {
        this.showSwal(
          "Document not present for download",
          "upload document first",
          "error"
        );
      }
    },
    selectDocument(value) {
      this.applicationCondition = value;
      this.modals.notice = true;
      this.selectedAppConditionId = value.applicationConditionId;
      this.$store.dispatch("loadConditionDocuments", value.loanApplicationId);
    },
    async addToExistingDocument(value) {
      // this.ociLog(this.selectedDocumentId)
      let object = {
        appCondId: this.selectedAppConditionId,
        docId: this.selectedDocumentId,
        loanAppId: this.loanApplicationId,
      };
      this.applicationConditionsLoading = true;
      await this.$store.dispatch("addToExistingDocument", object);
      this.applicationConditionsLoading = false;
      this.selectedDocumentId = null;
      this.modals.notice = false;
    },
    removeApplicationCondition() {
      this.modals.classic = true;
    },
    deleteApplicationCondition(multipleSelection) {
      this.modals.classic = false;
      for (let i = 0; i < multipleSelection.length; i++) {
        this.$store
          .dispatch("deleteApplicationCondition", multipleSelection[i])
          .then(() => {
            this.showSwal("Deleted Successfully", "", "success");
          });
      }
    },
    getAllApplicants() {
      this.$store.dispatch(
        "getAllAppApplicantsByLoanAppId",
        this.loanApplicationId
      );
    },
    checkSharedConditionsWithLender(value) {
      this.editing = null;
      let titleCheck = null;
      if (value.sharedWithLender) {
        titleCheck = "Access granted to lender";
      } else {
        titleCheck = "Access revoked from lender";
      }
      if (value) {
        this.$store
          .dispatch("checkSharedConditionsWithLender", value)
          .then(() => {
            if (this.$store.getters.confirmEmailSent) {
              this.showSwal(titleCheck, "", "success");
            } else {
              this.showSwal(
                "Error Occurred",
                "Retry or contact your admin",
                "error"
              );
            }
          });
      }
    },
    checkSharedConditionsWithBroker(value) {
      this.editing = null;
      let titleCheck = null;
      if (value.sharedWithBroker) {
        titleCheck = "Access granted to OCI";
      } else {
        titleCheck = "Access revoked from OCI";
      }
      if (value) {
        this.$store
          .dispatch("checkSharedConditionsWithBroker", value)
          .then(() => {
            if (this.$store.getters.confirmEmailSent) {
              this.showSwal(titleCheck, "", "success");
            } else {
              this.showSwal(
                "Error Occurred",
                "Retry or contact your admin",
                "error"
              );
            }
          });
      }
    },
    checkSharedConditionsWithLawyer(value) {
      this.editing = null;
      let titleCheck = null;
      if (value.sharedWithLawyer) {
        titleCheck = "Access granted to Lawyer";
      } else {
        titleCheck = "Access revoked from Lawyer";
      }
      if (value) {
        this.$store
          .dispatch("checkSharedConditionsWithLawyer", value)
          .then(() => {
            if (this.$store.getters.confirmEmailSent) {
              this.showSwal(titleCheck, "", "success");
            } else {
              this.showSwal(
                "Error Occurred",
                "Retry or contact your admin",
                "error"
              );
            }
          });
      }
    },
    showSwal(title, text, type) {
      swal({
        title: title,
        text: text,
        type: type,
        timer: 3000,
      });
    },
  },
};
</script>
<style>
.ocCondTypeButton {
  width: 190px;
  height: 30px;
  margin: 5px 5px 5px 0px;
}

.oc-elipsis {
  background-color: orangered;
  color: #007dc2;
}

.oci-icon-btn {
  background-color: white;
  border: none;
  color: DodgerBlue;
  padding: 5px 6px;
  font-size: 16px;
  cursor: pointer;
}

/*.my-dropdown {
    float: right;
    cursor: pointer;
    transform: translate(0%, 0px);
    min-width: 200px;
    height: 30px;
    margin-top: 5px;
  }

  .selected {
    display: block;
    width: 100%;
    height: 30px;
    padding: 0 20px;
    background: #0077B5;
    padding-top: 5px;
    color: #fff;
  }

  .selected:after {
    opacity: 0.5;
    display: inline-block;
    margin-left: 95px;
    content: '▼';
  }

  .selected:hover:after {
    opacity: 1;
  }

  .options {
    position: absolute;
    left: 0;
    top: 100%;
    z-index: 1;
    width: 100%;
    margin-top: 3px;
    background: #fff;
    border-radius: 10px;
  }

  .option {
    padding: 5px 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.25);
    border-left: 1px solid rgba(0, 0, 0, 0.25);
    border-right: 1px solid rgba(0, 0, 0, 0.25);
  }

  .option:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }*/

.oci-btn-primary {
  color: #007dc2;
  background-color: #ffffff;
  border-radius: 0px;

  width: 190px;
  height: 30px;
  margin: 5px 5px 5px 0px;
}

.oci-btn-primary:hover {
  color: white;
  background-color: #007dc2;
  /*box-shadow: inset 0 0 0 20rem #007dc2;*/
}

.oci-btn-success {
  color: #7bbf00;
  background-color: #ffffff;
  border-radius: 5px;

  width: 190px;
  height: 30px;
  margin: 5px 5px 5px 0px;
}

.oci-btn-success:hover {
  color: white;
  background-color: #7bbf00;
  /*box-shadow: inset 0 0 0 20rem #007dc2;*/
}

.oci-btn-secondary {
  color: white;
  background-color: #888888;
  border-radius: 5px;

  width: 190px;
  height: 30px;
  margin: 5px 5px 5px 0px;
}
</style>
